<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<div
		:id="`todo-parent-loading${todo.id}`"
		:class="[
			'vs-con-loading__container my-4 todo-parent-container',
			{ 'todo-tree-hide-multi-level': !childProperties(todo.properties).count_children > 0 },
			{ 'border-content-expand': !isContentCollapsed }
		]"
	>
		<vx-card :ref="`parentTodo${todo.id}`" :collapseAction="true" @toggleCollapse="handleChange">
			<div slot="title">
				<div :class="['flex flex-row items-center w-full px-4 todo-parent-title cursor-pointer']" @click="handleClickTodoItemRow($event, todo)">
					<cbs-color-picker
						:ref="`colorPickerRef-${todo.id}`"
						:value="todo.userOptionColor"
						mode="flag"
						:colors="noteColors"
						:listHeaderText="''"
						@input="color => handleSetMarkedColor(todo.id, color)"
					/>
					<div class="w-1/5" :set="department=getDepartment(todo)">
						<span :title="department.name" v-if="department" :style="{backgroundColor: department.color ? department.color : 'rgb(104, 134, 197)', color: 'white', borderRadius: '5px', padding: '5px', maxWidth: '120px', whiteSpace: 'nowrap', display: 'inline-block', textOverflow: 'ellipsis', overflow: 'hidden'}" class="ml-2">
							{{department.name}}
						</span>
					</div>
					<p class="w-4/5 pl-4 leading-normal font-semibold">{{ todo.name }}</p>
					<p :class="['font-bold todo-item-status font-medium w-1/5 ']">
						<span v-if="todo.type === $constant.TODO_TYPE.NORMAL" :class="[renderStatusColor(todo.status_object.key)]">
							<span>
								{{ todo.status_object.value }}
							</span>
						</span>
						<span v-else :class="['font-bold', childProperties(todo.properties).schedule_enable ? 'text-primary' : 'text-danger']">
							{{ childProperties(todo.properties).schedule_enable ? $t("Repeater.TurnedOn") : $t("Repeater.TurnedOff") }}
						</span>
					</p>
					<div class="w-2/5">
						<span v-if="todo.employees">
							<span v-for="employee in todo.employees.slice(0, 3)" :key="employee.id">
								<vx-tooltip class="inline-block" :text="employee.name" position="top">
									<vs-avatar :src="employee.avatar" />
								</vx-tooltip>
							</span>
							<span v-if="todo.employees.length > 3">
								<el-tooltip class="item" effect="dark" placement="right">
									<span slot="content">
										<p v-for="employee in todo.employees.slice(3, todo.employees.length + 1)" :key="employee.id">{{ employee.name }}</p>
									</span>
									<vs-avatar :text="`+${todo.employees.length - 3}`" />
								</el-tooltip>
							</span>
						</span>
					</div>
					<div class="w-1/5">
						<p :class="['todo-item-deadline font-medium', { 'text-over-time': todo.is_over_due }]">{{ childProperties(todo.properties).deadline | dateTime(userDateTimeFormat) }}</p>
						<p :class="['todo-item-deadline font-medium ']">{{ todo.done_at | dateTime(userDateTimeFormat) }}</p>
					</div>
					<div class="w-1/5">
						<div class="flex items-center h-full" v-if="hasReview(todo)">
							<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(todo, 1) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
							<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(todo, 2) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
							<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(todo, 3) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
							<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(todo, 4) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
							<i :style="{fontSize: '1.5rem', cursor: 'pointer', color: checkReview(todo, 5) ? '#F2994A' : '#828282'}" class="nucleo nucleo-priority-S1"/>
						</div>
					</div>
					<TodoItemContextMenu
						type="vertical"
						:todoItem="todo"
						@onClickEdit="data => callEmitEvent('onClickEdit', data)"
						@onClickRecreate="data => callEmitEvent('onClickRecreate', data)"
						@onClickReminder="data => callEmitEvent('onClickReminder', data)"
						@onClickCancel="data => callEmitEvent('onClickCancel', data)"
						@onClickReject="data => callEmitEvent('onClickReject', data)"
						@onClickCreateRequest="data => callEmitEvent('onClickCreateRequest', data)"
						@onClickToggleScheduleTodo="data => callEmitEvent('onClickToggleScheduleTodo', data)"
						@onClickAddDetail="data => callEmitEvent('onClickAddDetail', data)"
						@viewDetail="data => callEmitEvent('viewDetail', data)"
						@onClickWatcher="data => callEmitEvent('onClickWatcher', data)"
						@onSetStatusTodo="(...data) => callEmitEvent('onSetStatusTodo', ...data)"
						@onCompleteTodo="(...data) => callEmitEvent('onCompleteTodo', ...data)"
						@onClickCreateClone="data => callEmitEvent('onClickCreateClone', data)"
						@onClickSettingTimeRepeater="data => callEmitEvent('onClickSettingTimeRepeater', data)"
					/>
					<!-- </div> -->
				</div>
			</div>
			<div v-if="todoListChilds.length > 0">
				<TodoTree
					v-for="child in todoListChilds"
					:key="`parentChild${child.id}`"
					:todo="child"
					@onClickEdit="data => callEmitEvent('onClickEdit', data)"
					@onClickRecreate="data => callEmitEvent('onClickRecreate', data)"
					@onClickReminder="data => callEmitEvent('onClickReminder', data)"
					@onClickCancel="data => callEmitEvent('onClickCancel', data)"
					@onClickReject="data => callEmitEvent('onClickReject', data)"
					@onClickCreateRequest="data => callEmitEvent('onClickCreateRequest', data)"
					@onClickToggleScheduleTodo="data => callEmitEvent('onClickToggleScheduleTodo', data)"
					@onClickAddDetail="data => callEmitEvent('onClickAddDetail', data)"
					@viewDetail="data => callEmitEvent('viewDetail', data)"
					@onSetMarkedColor="(todoId, color) => callEmitEvent('onSetMarkedColor', todoId, color)"
					@onSetStatusTodo="(...data) => callEmitEvent('onSetStatusTodo', ...data)"
					@onCompleteTodo="(...data) => callEmitEvent('onCompleteTodo', ...data)"
					@onClickCreateClone="data => callEmitEvent('onClickCreateClone', data)"
					@onClickSettingTimeRepeater="data => callEmitEvent('onClickSettingTimeRepeater', data)"
					@onClickWatcher="data => callEmitEvent('onClickWatcher', data)"
				/>
				<el-pagination class="text-right" layout="prev, pager, next" :page-size="limit" :total="totalChilds" @current-change="handlePageChange" :current-page.sync="page"> </el-pagination>
			</div>
		</vx-card>
	</div>
</template>

<script>
import CbsColorPicker from "@/components/cbs-color-picker/CbsColorPicker";
import TodoItemContextMenu from "./TodoItemContextMenu";
import TodoTree from "./TodoTree";

import { mapGetters } from "vuex";
import { Pagination } from "element-ui";
import { Tooltip } from "element-ui";

export default {
	name: "TodoParentCollapseItem",
	components: {
		CbsColorPicker,
		TodoItemContextMenu,
		"el-pagination": Pagination,
		TodoTree,
		"el-tooltip": Tooltip
	},
	props: {
		todo: {
			type: Object
		},
		filters: {
			type: Object
		}
	},
	data() {
		return {
			page: 1,
			limit: 10,
			totalChilds: 0,
			isContentCollapsed: false
		};
	},
	computed: {
		noteColors() {
			return this.$constant.PICKER_MARK_COLORS || [];
		},
		...mapGetters({
			getTodoChildByParent: "todoListManagement/getTodoChildByParent"
		}),
		todoListChilds() {
			return this.getTodoChildByParent(this.todo, this.filters) || [];
		}
	},
	methods: {
		getDepartment(todo) {
			return todo.creater && todo.creater.employee && todo.creater.employee.department ? todo.creater.employee.department : null;
		},
		hasReview(todo) {
			let props = JSON.parse(todo.properties);
			return props && props.hasOwnProperty('review');
		},
		checkReview(todo, num) {
			let props = JSON.parse(todo.properties);
			let review = 0;
			if (props && props.hasOwnProperty('review')) {
				review = parseInt(props.review);
			}
			if (review) {
				return parseInt(review) >= num;
			}
			return false;
		},
		async handleChange(param) {
			this.isContentCollapsed = param;
			if (!param) {
				this.$store.dispatch("todoListManagement/removeOldChildItems", this.todoListChilds);
				this.$refs[`parentTodo${this.todo.id}`].refreshcard();
				await this.getChilds();
				this.$refs[`parentTodo${this.todo.id}`].removeRefreshAnimation();
			}
		},
		async getChilds() {
			const queryOptions = {
				limit: this.limit,
				page: this.page,
				type: this.$constant.TODO_TYPE.NORMAL,
				parent_id: this.todo.id,
				...this.filters
			};

			const respone = await this.$store.dispatch("todoListManagement/getTodoChildByParent", queryOptions);
			this.totalChilds = respone.totalTodoList;
		},

		childProperties(properties) {
			return JSON.parse(properties);
		},

		handleClickTodoItemRow(event, todoItem) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find(className => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				this.$emit("viewDetail", todoItem);
			}
		},
		callEmitEvent(event, ...data) {
			this.$emit(event, ...data);
		},
		handleSetMarkedColor(todoId, color) {
			this.$emit("onSetMarkedColor", todoId, color);
		},
		async handlePageChange(currentPage) {
			this.$store.dispatch("todoListManagement/removeOldChildItems", this.todoListChilds);
			this.page = currentPage;
			this.$refs[`parentTodo${this.todo.id}`].refreshcard();
			await this.getChilds();
			this.$refs[`parentTodo${this.todo.id}`].removeRefreshAnimation();
		},
		async reFetchChilds(parentId) {
			this.page = 1;
			this.$store.dispatch("todoListManagement/removeOldChildItems", this.todoListChilds);
			this.$refs[`parentTodo${parentId}`].refreshcard();
			await this.getChilds();
			this.$refs[`parentTodo${parentId}`].removeRefreshAnimation();
			if (this.$refs[`parentTodo${parentId}`].reFetchChilds) {
				this.$refs[`parentTodo${parentId}`].reFetchChilds(parentId);
			}
		}
	},
	mounted() {
		this.$refs[`parentTodo${this.todo.id}`].toggleContent();
	}
};
</script>

<style lang="scss">
.todo-parent-container {
	box-sizing: border-box;
	border-radius: 8px;
	.vx-card {
		.vx-card__header {
			background-color: var(--color-gray-7);
			padding: 0.8rem;
			.vx-card__title {
				flex-basis: calc(100% - 30px);
			}
		}
		.vx-card__body {
			padding: 0 !important;
		}
	}
	&.todo-tree-hide-multi-level {
		> .vx-card {
			.vx-card__actions {
				display: none;
			}
		}
	}
}
.border-content-expand {
	border: 1px solid #e0e0e0;
}
</style>
